import store from '@/store'
import axios from 'axios' 

export default {

  async getShoppers () {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.get(store.getters.getShopperApi + '/shoppers', headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null}
      }
    } catch (e) {
      let error = {e}
      console.log('error', error.e)
      return { error: true, code: 500, msg:'Erro ao obter shoppers'}
    }
  },

  async saveShopper (shopper) {
    try {
      
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.post(store.getters.getShopperApi + '/shoppers',
      shopper, headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null}
      }
    } catch (e) {
      let error = {e} 
      console.log('error', error.e)
      return { error: true, code: 500, msg:'Erro ao atualizar shopper'}
    }
  },

  async deleteShopper (email) {
    try {
      let result= await axios.delete(store.getters.getShopperApi + '/shoppers?email=' + email)
      if (result.data) {
        return result.data
      } else {
        return { error: true, data: null, msg: 'erro ao excluir shopper'}
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      return {error: true, data: error}
    }
  }
}